<template>
  <div class="user-unknown-page">
    <div class="user-unknown-card">
      <v-icon size="48" color="grey lighten-1">mdi-account-alert-outline</v-icon>
      <div class="mt-3 title-text">{{ $t(page+'.User not recognized') }}</div>
      <div class="mt-2 subtitle-text">
        {{ $t(page+'.Sorry, this account does not exiss.') }}
      </div>
      <!--
      <v-btn
        depressed
        class="mt-6 retry-btn"
        color="#FFA000"
        @click="goHome"
      >
        {{ $t(page+'.Back to sign in') }}
      </v-btn>
      -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Unknown',
  data() {
    return {
      page: 'unknown',
    }
  },
  methods: {
    goHome() {
      this.$router.push('/sd').catch(() => {});
    },
  },
}
</script>

<style scoped>
.user-unknown-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 24px;
}

.user-unknown-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: 360px;
  width: 100%;
  padding: 48px 32px;
  border: 1.5px solid #e0e0e0;
  border-radius: 16px;
  background: #fff;
}

.title-text {
  font-size: 1.05rem;
  font-weight: 700;
  color: #37474F;
}

.subtitle-text {
  font-size: 0.85rem;
  line-height: 1.5;
  color: #757575;
}

.retry-btn {
  color: #fff !important;
  font-weight: 700;
  border-radius: 10px;
  text-transform: none;
  letter-spacing: 0.02em;
  padding: 0 24px !important;
}
</style>